import { render, staticRenderFns } from "./DocumentDetailsRecurringListing.vue?vue&type=template&id=d8a4e8b2"
import script from "./DocumentDetailsRecurringListing.vue?vue&type=script&lang=js"
export * from "./DocumentDetailsRecurringListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports